import React from "react";
import { bg_shadow } from "constant/css";

const Method = ({
  icon,
  title,
  onClick,
  disabled = false,
  description = null,
  selected = false,
}) => {
  return (
    <div
      role="button"
      tabIndex={disabled ? -1 : 0}
      onClick={!disabled ? onClick : undefined}
      onKeyDown={(e) => {
        if (!disabled && (e.key === "Enter" || e.key === " ")) onClick?.();
      }}
      className={`flex h-auto w-full flex-col gap-2 rounded-xl border bg-white p-3 transition-all duration-200
        ${selected ? "border-smartTeal ring-2 ring-smartCyan/30" : "border-slate-100"}
        ${bg_shadow}
        ${
          disabled
            ? "cursor-not-allowed opacity-40"
            : "cursor-pointer hover:border-smartCyan"
        }`}
    >
      <div className="flex items-start">{icon}</div>
      <span className="text-sm leading-snug text-slate-700">{title}</span>
      {description && (
        <span className="text-xs leading-tight text-slate-500" style={{ marginTop: -4 }}>
          {description}
        </span>
      )}
    </div>
  );
};

export default Method;
